let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jycv9"), load("XfwMA")]).then(() => parcelRequire('hKxxO'));